import * as React from 'react';
import { CustomerTag } from '../CustomerTag';

interface Props {
  code: string;
  onClick: () => void;
}

export const Create: React.FC<Props> = (props) => {
  const { code, onClick } = props;
  return (
    <div
      className="w-full h-7 space-x-2 px-2 py-1 bg-gray-300 rounded flex items-center cursor-pointer overflow-hidden"
      onClick={onClick}
    >
      <h4 className="font-medium text-gray-800">Create</h4>
      <CustomerTag customer={{ code, count: 0, id: '', createdBy: '' }} />
    </div>
  );
};
Create.displayName = 'CustomerTag.Search.Create';
